// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 17) return "static/js/85ec2fe629d6ac333e67.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"b351d5912e8e08ef8297","180":"b4d4fe0491009bac5db8","181":"67d7cecb7a8365e87d63"}[chunkId] + ".chunk.js";
};